import { ReactComponent as ApproachCircle } from 'assets/approach-circle.svg';
import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';
import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
//import Plx from 'react-plx'; //^1.3.15
import { containers, Grid } from 'style';
import { Markdown } from '..';

class ApproachComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rotation: 0,
            totalscroll: 0,
            windowHeight: 0,
            circle1active: false,
            circle2active: false,
            circle3active: false
        }
        this.circle = React.createRef();
        this.circle1;
        this.circle2;
        this.circle3;

        this.gotoSection = this.gotoSection.bind(this);

        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollSnap = this.handleScrollSnap.bind(this);
        this.scrollToFirst = this.scrollToFirst.bind(this);

        this.trottledScroll = throttle(this.handleScroll, 50);
        this.trottledScrollSnapp = debounce(this.handleScrollSnap, 100);
    }

    componentDidMount() {
        this.handleResize();
        this.addEventListeners();
        this.circle1 = document.querySelector('#group1 g');
        this.circle2 = document.querySelector('#group2 g');
        this.circle3 = document.querySelector('#group3 g');

        /*this.circle1.onclick = () => { this.gotoSection('#section1', window.innerHeight) };
        this.circle2.onclick = () => { this.gotoSection('#section2', window.innerHeight * 2) };
        this.circle3.onclick = () => { this.gotoSection('#section3', window.innerHeight * 3.6) };
        */
    }
    componentWillUnmount() {
        this.removeEventListeners();
    }
    offset(el) {
        var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }

    gotoSection(section, y) {
        const bounds = this.offset(document.querySelector(section));
        //console.log(section, y, window.innerHeight);
        //window.scrollTo({ top: y })
    }
    handleScrollSnap() {
        //console.log('handleScrollSnap');
        let target = document.querySelector('.Plx--active');
        if (!target) {
            target = document.querySelector('.Plx--above');
        }
        if (target) {
            window.scrollTo({ top: this.offset(target).top, behavior: 'smooth' })
        }
    }
    scrollToFirst() {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })
    }
    handleScroll() {
        const pct = (window.pageYOffset / this.state.totalscroll);
        const pct1 = (window.pageYOffset / this.state.windowHeight);
        // console.log('scroll', 360 * pct, this.circle.current.style);
        // this.setState({ rotation: pct <= 1 ? 360 * pct : 360, circle1active: pct > .2 && pct < .5, circle2active: pct > .5 && pct < .8, circle3active: pct > .8 });
        if (pct <= 1) {
            this.circle.current.style.transform = `rotate(${360 * pct}deg)`;
            this.circle1.style.transform = `rotate(-${360 * pct}deg)`;
            this.circle2.style.transform = `rotate(-${360 * pct}deg)`;
            this.circle3.style.transform = `rotate(-${360 * pct}deg)`;
            this.circle.current.style.opacity = 1;
        } else {
            this.circle.current.style.transform = `rotate(360deg)`;
            this.circle1.style.transform = `rotate(-360deg)`;
            this.circle2.style.transform = `rotate(-360deg)`;
            this.circle3.style.transform = `rotate(-360deg)`;
            this.circle.current.style.opacity = (1 - ((pct - 1) * 8));
        }
        if (pct > .2 && pct < .5) {
            this.circle1.classList.add('active');
        } else {
            this.circle1.classList.remove('active');
        }
        if (pct > .5 && pct < .8) {
            this.circle2.classList.add('active');
        } else {
            this.circle2.classList.remove('active');
        }
        if (pct > .8) {
            this.circle3.classList.add('active');
        } else {
            this.circle3.classList.remove('active');
        }
        //console.log('handleScroll', pct);

        // this.circle.current.style.transform = `rotate(${360 * pct}deg)`;
    }
    handleResize() {
        //console.log('handleResize');
        this.setState({ totalscroll: window.innerHeight * 3, windowHeight: window.innerHeight });
    }
    addEventListeners() {
        // this.circles = document.querySelectorAll('.approach_circle circle');
        window.addEventListener('scroll', this.trottledScroll);
        window.addEventListener('scroll', this.trottledScrollSnapp);
        window.addEventListener('resize', this.handleResize);
    }

    removeEventListeners() {
        window.removeEventListener('scroll', this.trottledScroll);
        window.removeEventListener('scroll', this.trottledScrollSnapp);
        window.removeEventListener('resize', this.handleResize);
    }
    render() {
        const { heroText, sections, section1, section2, section3 } = this.props;
        const { rotation, circle1active, circle2active, circle3active } = this.state;

        const parallaxDataHero = [
            {
                start: 'self',
                duration: '10vh',
                startOffset: '130vh',
                properties: [
                    {
                        startValue: 1,
                        endValue: 0,
                        property: 'opacity',
                    },
                ],
            },
        ];

        const parallaxData1 = [
            {
                start: 'self',
                duration: '10vh',
                startOffset: '60vh',
                properties: [
                    {
                        startValue: 0,
                        endValue: 1,
                        property: 'opacity',
                    },
                ],
            },
            {
                start: 'self',
                duration: '10vh',
                startOffset: '130vh',
                properties: [
                    {
                        startValue: 1,
                        endValue: 0,
                        property: 'opacity',
                    },
                ],
            },
        ];
        return (
            <Grid.Wrapper>
                <HeroCursor data-cursor="hero"
                    data-cursor-persistance="400" onClick_={this.scrollToFirst}>
                    <Grid.InnerContainer id="ApproachComponent">
                        <ApproachCircleWrapperWrapper>
                            <ApproachCircleWrapper circle1active={circle1active} circle2active={circle2active} circle3active={circle3active} backgroundColor={'#fff070'}>
                                <div ref={this.circle} className="approach_circle">
                                    <ApproachCircle />
                                </div>
                            </ApproachCircleWrapper>
                        </ApproachCircleWrapperWrapper>

                        <ApproachSection
                        >
                            {/* <Plx
                                css={approach_left_hero}
                                animateWhenNotInViewport={true}
                                parallaxData={parallaxDataHero}>
                                <div css={approach_text}>
                                    <h2 css={markdown}>{heroText}</h2>
                                </div>
                            </Plx> */}
                            {/* <div className={approach_hero_left}>

                </div> */}
                        </ApproachSection>
                    </Grid.InnerContainer>
                </HeroCursor>
                <Grid.InnerContainer id="ApproachComponent">


                    <ApproachSection
                        id="section1"
                    >
                        {/* <Plx
                            css={approach_left}
                            animateWhenNotInViewport={true}
                            parallaxData={parallaxData1}>
                            <div css={approach_text}>
                                <Markdown source={section1} css={markdown} />
                            </div>
                        </Plx> */}
                    </ApproachSection>
                    <ApproachSection
                        id="section2"
                    >
                        {/* <Plx
                            css={approach_left}
                            animateWhenNotInViewport={true}
                            parallaxData={parallaxData1}>
                            <div css={approach_text}>
                                <Markdown source={section2} css={markdown} />
                            </div>
                        </Plx> */}
                    </ApproachSection>
                    <ApproachSection
                        id="section3"
                    >
                        {/* <Plx
                            css={approach_left}
                            animateWhenNotInViewport={true}
                            parallaxData={parallaxData1}>
                            <div css={approach_text}>
                                <Markdown source={section3} css={markdown} />
                            </div>
                        </Plx> */}
                    </ApproachSection>

                    {/* {caseSections.map((el) => <div key={`section_${el.id}`} className={el.active ? 'active' : ''}>{el.sectionTitle}</div>)} */}

                </Grid.InnerContainer>
            </Grid.Wrapper>
        )
    }
}

const HeroCursor = styled.div`
  height: 100vh;
  width: 100%;
`;

const ApproachSection = styled.div`
    width: 100%;
    height: 100vh;
    position: relative;
`;


const approach_left = css`
  width: 100%;
  height: 50%;
  opacity: 0;
  position: relative;

  @media (orientation: landscape){
    margin-left: auto;
    width: 50%;
    height: 100%;
    left: 0;
  }
`;
const approach_left_hero = css`
  ${approach_left};
  opacity: 1;

`;
const approach_text = css`
  /* max-width: calc(1330px / 2); */
  position: fixed;
  bottom: 21%;
  left: 11%;
  width: 78%;
  transform: translateY(50%);

  @media (orientation: landscape){
    margin-left: 5.5vw;
    left: auto;
    width: 28%;
    bottom: auto;
    top: 50%;
    transform: translateY(-60%);
  }
`;
const markdown = css`
  margin-right: 6%;
`;


const ApproachCircleWrapperWrapper = styled.div`
    position: absolute;
    height: 50vh;
    z-index: 10;
    @media (orientation: landscape){
      width: 43%;
      height: 100vh;
      left: 11%;

      @media (min-width: ${containers.innerPX}px) {
        left: 0;
      }
    }
`
const ApproachCircleWrapper = styled.div`
  width: 60%;
  position: fixed;
  top: 38%;

  @media (orientation: portrait) and (max-width: 767px){
    width: 80%;
    top: 34%;
  }
  transform: translateY(-50%) translateX(-50%);

  @media (orientation: landscape){
    margin-left: -1vw;
    max-width: 36vw;
    top: 50%;
    transform: translateY(-55%);
  }
  .approach_circle{
    transform-origin: 50% 57%;
  }
  svg{

    width: 100%;
    height: auto;
    overflow: visible;

    text{
      font-family: 'TomoSans',Arial, Helvetica, sans-serif;
    }
    & > g {

    }
    circle{
      /* transform-origin: 48% 56%; */
      transform-origin: 21% 24%;
    }
    #center {
      stroke: transparent;
    }
    #group1, #group2, #group3{
      g{
        transform-origin: 21% 22.5%;

        circle{
          fill: #fff;
          stroke: transparent;
          transition: transform 500ms, fill 500ms;
        }
        text{
          transition: fill 500ms;
        }
      }
    }
    g.active {
      circle{
        /* transform: scale(1.2); */
        fill: #000 !important;
      }
      text{
        fill: #FFFFFF;
      }
    }
  }
`;

export default ApproachComponent;
